import { render, staticRenderFns } from "./ArticlesOfAgreement.vue?vue&type=template&id=0f72ccbf&scoped=true&"
import script from "./ArticlesOfAgreement.vue?vue&type=script&lang=js&"
export * from "./ArticlesOfAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesOfAgreement.vue?vue&type=style&index=0&id=0f72ccbf&lang=scss&rel=text%2Fcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72ccbf",
  null
  
)

export default component.exports